import React, { useRef, useEffect } from "react";
import anime from "animejs/lib/anime.es.js";
import styled from "styled-components";

import {
  randomRange,
  correctSound,
  incorrectSound,
  blockTouch,
  getWord,
} from "@stores/vars";
import playSound from "@/sound";

const Wrap = styled.div.attrs((props) => ({
  style: {
    top: props.y,
  },
}))`
  position: absolute;
  display: flex;
  display: flex;
  width: 1920px;
  justify-content: space-evenly;
  z-index: -1;
`;

const Box = styled.div`
  position: relative;
  width: 259px;
  height: 259px;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  > img {
    width: 100%;
  }
`;
const Word = styled.div`
  position: absolute;
  top: 230px;
  padding: 10px 20px;
  background-color: #fff;
  color: #000;
  font-family: Noto Sans SC;
  font-size: 45px;
  max-width: 500px;
  //width: 450px;
  white-space: nowrap;
  word-break: break-all;
  text-align: center;
  box-sizing: border-box;
  border-radius: 35px;
`;
const donutsImages = [
  require("@assets/img/donutgame/item1.png"),
  require("@assets/img/donutgame/item2.png"),
  require("@assets/img/donutgame/item3.png"),
  require("@assets/img/donutgame/item4.png"),
  require("@assets/img/donutgame/item5.png"),
  require("@assets/img/donutgame/item6.png"),
  require("@assets/img/donutgame/item1.png"),
  require("@assets/img/donutgame/item2.png"),
  require("@assets/img/donutgame/item3.png"),
  require("@assets/img/donutgame/item4.png"),
  require("@assets/img/donutgame/item5.png"),
  require("@assets/img/donutgame/item6.png"),
  require("@assets/img/donutgame/item1.png"),
  require("@assets/img/donutgame/item2.png"),
  require("@assets/img/donutgame/item3.png"),
  require("@assets/img/donutgame/item4.png"),
  require("@assets/img/donutgame/item5.png"),
  require("@assets/img/donutgame/item6.png"),
];

const Donuts = ({
  data,
  uKey,
  speed,
  onSuccess,
  onFail,
  answerWord,
  isStart,
  categoryKey,
}) => {
  const itemRef = useRef();
  // 전체높이 - 도너츠 높이 - 바구니 높이 / 2
  const bottom = 1200 - 259 - 250;
  const boxRef = useRef([
    React.createRef(),
    React.createRef(),
    React.createRef(),
  ]);
  const check = () => {
    if (window.__isTimeout) return;
    blockTouch();
    const basket = document.querySelector("#basket");
    if (!basket) return;
    const basketRect = basket.getBoundingClientRect();
    const bX = basketRect.left;
    const bXE = bX + basketRect.width;
    let inItem = null;

    for (let i = 0; i < boxRef.current.length; i++) {
      const donut = boxRef.current[i].current;
      if (donut) {
        const donutReact = donut.getBoundingClientRect();
        const dX = donutReact.left;
        const dXE = dX + donutReact.width;

        if (bX <= dX && dXE <= bXE) {
          inItem = donut;
          break;
        }
      }
    }

    if (inItem) {
      const cWord = inItem.getAttribute("data-word");
      const cImg = inItem.getAttribute("data-img");
      const sound = inItem.getAttribute("data-sound");

      for (let i = 0; i < boxRef.current.length; i++) {
        const el = boxRef.current[i].current;
        anime({
          targets: el,
          scale: [1, 0.9],
          opacity: [1, 0],
          easing: "easeInBack",
          duration: 500,
        });
      }

      const w = getWord(answerWord, categoryKey);
      if (cWord === w) {
        playSound.effect(correctSound);
        anime.remove(inItem);
        anime({
          targets: inItem,
          scale: [1, 0.5],
          opacity: [1, 0],
          translateY: 310,
          easing: "easeInCubic",
          duration: 500,
          endDelay: 100,
          complete: () => {
            onSuccess(cImg, sound);
          },
        });
      } else {
        playSound.effect(incorrectSound);
        anime.remove(inItem);
        anime({
          targets: inItem,
          scale: [1, 1],
          opacity: [1, 0],
          translateY: -150,
          easing: "easeOutCirc",
          duration: 300,
          endDelay: 100,
          complete: () => {
            onFail();
          },
        });
      }
    } else {
      playSound.effect(incorrectSound);
      for (let i = 0; i < boxRef.current.length; i++) {
        const el = boxRef.current[i].current;
        anime({
          targets: el,
          scale: [1, 0.9],
          opacity: [1, 0],
          easing: "easeInBack",
          duration: 500,
        });
      }

      setTimeout(() => {
        onFail();
      }, 500);
    }
    //onRemove(data.uKey, ani);
  };

  useEffect(() => {
    for (let i = 0; i < boxRef.current.length; i++) {
      const el = boxRef.current[i].current;
      anime.set(el, {
        scale: function () {
          return 1;
        },
        opacity: function () {
          return 1;
        },
        rotate: function () {
          return 0;
        },
        translateY: function () {
          return 0;
        },
      });
    }
    anime({
      targets: itemRef.current,
      translateY: [-290, bottom],
      easing: "linear",
      duration: speed,
      complete: () => {
        check();
      },
    });

    return () => {
      anime.running.forEach(function (ani) {
        ani.pause();
      });
      for (let i = 0; i < boxRef.current.length; i++) {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        const a = boxRef.current[i];
        anime.remove(a.current);
      }
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return (
    <Wrap ref={itemRef} className="g-word-item">
      {data.map((a, i) => {
        const img = donutsImages[randomRange(0, 17)];
        const word = getWord(a.word, categoryKey);
        return (
          <Box
            key={i}
            ref={boxRef.current[i]}
            data-word={word}
            data-img={img}
            data-sound={a.sound}
            className="bb-item"
          >
            <img src={img} alt="" />
            <Word>
              <div dangerouslySetInnerHTML={{ __html: word }} />
            </Word>
          </Box>
        );
      })}
    </Wrap>
  );
};

export default Donuts;
